import { useState } from 'react'
import { PiInfo } from 'react-icons/pi'

interface ValueWithTooltipProps {
  amount: string
  tooltip: string
}

export const ValueWithTooltip = ({ amount, tooltip }: ValueWithTooltipProps) => {
  const [showTooltip, setShowTooltip] = useState(false)

  return (
    <span className="flex items-center gap-1">
      <span className="text-zinc-400">{amount}</span>
      <button
        type="button"
        className="relative focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white rounded"
        onClick={(e) => {
          e.stopPropagation()
          setShowTooltip(!showTooltip)
        }}
        onBlur={() => setShowTooltip(false)}
      >
        <PiInfo className="w-4 h-4 text-zinc-400" />
        <span
          role="tooltip"
          className={`absolute right-0 bottom-full mb-2 px-2 py-1 text-xs text-white bg-zinc-800 rounded-md whitespace-nowrap transition-all duration-200 z-10 ${showTooltip ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
        >
          {tooltip}
          <span className="absolute right-2 top-full border-4 border-transparent border-t-zinc-800" />
        </span>
      </button>
    </span>
  )
}

export default ValueWithTooltip
